export default function SectionHeading({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string | null;
}) {
  return (
    <div className="mb-4">
      <div className="text-xl font-semibold tracking-tight">{title}</div>
      {subtitle && (
        <h2 className="text-sm text-muted-foreground">{subtitle}</h2>
      )}
    </div>
  );
}
